import React from "react";
import orgLogo from "../../Assets/Auth/login/orgLogo2.png";

const OrgLogo = () => {
  return (
    <div className="logo-container">
      <img src={orgLogo} alt="Organization Logo" className="org-logo" />
    </div>
  );
};

export default OrgLogo;
